import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { News, PagedNews, CreateNews, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetNewsPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class NewsService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.news

    Get(): Observable<News[]> {
        return this._http.get<News[]>(this._apiUrl)
    }

    GetByMasterId(masterId: string): Observable<News> {
        return this._http.get<News>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetNewsPagedParams): Observable<PagedNews> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedNews>(request.url, { params: request.params })
    }
    PagedRequest(params: GetNewsPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createNews: CreateNews): Observable<News> {
        return this._http.post<News>(this._apiUrl, createNews)
    }

    Modify(masterId: string, data: ModifyObject): Observable<News> {
        return this._http.patch<News>(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
